import axiosClient from '../api/axiosClient';
import API from '../Constants/apiRoutes';

const authService = {
  /** POST /admin/auth/login -> { accessToken, expiresAtUtc, firstName, lastName, email, roles[] } */
  login: async ({ email, password }) => {
    const { data } = await axiosClient.post(API.auth.login, { email, password });
    return data;
  },
};

export default authService;
